import fse from 'fs-extra';
import path from 'path';
import {type PackageJson} from 'type-fest';

import {getConfigOrExit} from '@/utilities/config';

export const fetchLocalJson = async (currentWorkingDirectory: string = process.cwd()) => {
  const currentWorkingDirectoryPath = path.resolve(currentWorkingDirectory);
  return (await fse.readJSONSync(currentWorkingDirectoryPath)) as PackageJson;
};

export const readPackageVersion = async () => {
  try {
    const {version} = await import('../../package.json');
    return version;
  } catch (error) {
    return 'dev';
  }
};

export const fetchLocalPackage = async (currentWorkingDirectory: string = process.cwd()) =>
  (await fetchLocalJson(`${currentWorkingDirectory}/package.json`)) as PackageJson;

export const fetchFileFromGitRepository = async (filePath: string) => {
  const config = await getConfigOrExit();

  const requestHeaders: Headers = new Headers();
  requestHeaders.set('PRIVATE-TOKEN', config.gitlabToken ?? '');

  const response = await fetch(`${filePath}?ref=${process.env.GITLAB_REF_KOG ?? 'main'}`, {headers: requestHeaders});
  const responseText = await response.text();
  const responseJson = JSON.parse(responseText);
  const responseDecrypted = Buffer.from(responseJson.content || '', 'base64').toString('utf8');
  return responseDecrypted;
};

export const fetchJsonFromGitRepository = async (filePath: string) =>
  filePath ? JSON.parse(await fetchFileFromGitRepository(filePath)) : {name: '', version: 0};
